<div id="footer">

  <a target="_blank"
     href="https://ui.awin.com/user/legal-docs/privacy-policy"
     i18n="@@communication-centre.footer.privacy-policy">
    Privacy Policy
  </a>
  |
  <a target="_blank"
     href="https://ui.awin.com/user/legal-docs/user-agreement"
     i18n="@@communication-centre.footer.user-agreement">
    User Agreement
  </a>
  |
  <a target="_blank"
     href="https://www.awin.com">
    &copy; AWIN LTD {{now | date: 'yyyy'}}
  </a>

</div>
